import Button from './ui/Button';

type MobileAppDownloadsProps = {
  className?: string;
};

const MobileAppDownloads = ({ className }: MobileAppDownloadsProps) => {
  // Default so the button still shows even if env vars weren't injected at build time.
  // If you host the APK at /downloads/communitypay.apk on the same domain, no env config is required.
  const androidApkUrlFromEnv = ((import.meta as any)?.env?.VITE_ANDROID_APK_URL as string | undefined)?.trim();
  const androidApkUrl = androidApkUrlFromEnv || '/downloads/communitypay.apk';
  const iosTestflightUrl = (import.meta as any)?.env?.VITE_IOS_TESTFLIGHT_URL as string | undefined;

  return (
    <div className={className}>
      <div className="rounded-xl border border-border bg-muted/20 p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="text-sm font-semibold text-foreground">Get the mobile app</div>
            <div className="mt-1 text-xs text-muted-foreground">
              Download the Android app (APK) or open the iPhone link (TestFlight) if provided.
            </div>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-1 gap-2">
          <Button asChild variant="outline" size="sm" fullWidth iconName="Download" iconPosition="left">
            <a
              href={androidApkUrl}
              // For same-origin files (e.g. /downloads/communitypay.apk), this triggers a real download
              // instead of opening a blank/new tab. Browsers will ignore this for cross-origin URLs.
              download
              rel="noopener noreferrer"
            >
              Download Android APK
            </a>
          </Button>

          {iosTestflightUrl && (
            <Button asChild variant="outline" size="sm" fullWidth iconName="ExternalLink" iconPosition="left">
              <a href={iosTestflightUrl} target="_blank" rel="noopener noreferrer">
                iPhone (TestFlight)
              </a>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileAppDownloads;

